import { HStack } from "@/components/Layout";
import { Text } from "@/components/Typography/Text";
import { cn } from "@/lib/cn";

export interface Props extends React.HTMLAttributes<HTMLDivElement> {
  label: string;
  align?: "left" | "right";
}

export function SimpleHeader({ align = "left", className, label }: Props) {
  return (
    <HStack
      className={cn(
        align === "left" && "justify-start",
        align === "right" && "justify-end",
        className,
      )}
    >
      <Text
        variant="label"
        className="text-neutral-muted-on-fill first-letter:uppercase text-nowrap"
      >
        {label}
      </Text>
    </HStack>
  );
}
